import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, map, of, take } from 'rxjs';
import { ChatService } from '../../../shared/services/chat.service';
import { SharedService } from '../../../shared/services/shared.service';

@Component({
  selector: 'app-CallTranscript',
  templateUrl: './CallTranscript.component.html',
  styleUrls: ['./CallTranscript.component.scss']
})
export class CallTranscriptComponent implements OnInit {
  transcriptId: string;
  recordData: any;
  customerData: any;
  isMobile: boolean = false
  callTranscript: any;
  callDate: any;
  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CallTranscriptComponent>,
    private chatService: ChatService,
    private sharedService: SharedService,
  ) { 
    console.log({data});
    this.transcriptId = data.transcriptId;
    this.recordData = data.recordData;
    this.customerData = data.ticketData.customer
    // this.ticketData = data.ticketData;
    this.isMobile = this.isMobile;
    this.createCallTranscript()

  }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close()
  }

  createCallTranscript() {
    this.loading = true;
    this.chatService.getCallTranscript(this.recordData.id).pipe(
      take(1),
      map((callTranscriptObject: any) => {
        if(callTranscriptObject) {
          this.callDate = new Date(callTranscriptObject.recording_start)
          this.callTranscript = callTranscriptObject.timeline.map((e: any) => {
            return {
              name : this.getUserName(e.users[0]?.username),
              time : this.turnToTime(e.ts,e.end_ts),
              text: e.text
            }
          })
          console.log({callTranscript: this.callTranscript});
        }
        this.loading = false;

      }),
      catchError((err) => {
        console.log({err});
        this.loading = false;
        this.sharedService.changeMessage({ action: 'popup', actionData: 'error' })
        return of(null)
      })
    ).subscribe()
  }

  getUserName(user: any) {
    const userName = this.customerData.phoneNumber.includes(user.substr(-5)) ? this.customerData.name : 'Home365'
    return userName
  }


  getShortName(name: any) {
    if(!name) {
      return ''
    }
    let shortName = '';
    let nameObj = name?.split(" ");
    for(let n of nameObj) {
      shortName = `${shortName}${n[0]}`
    }
    return shortName.slice(0, 2)
  }


  turnToTime(startValue: any, endValue: any) {
    const startV = startValue.split(':');
    const endV = endValue.split(':');

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    const  startSeconds = (+startV[0]) * 60 * 60 + (+startV[1]) * 60 + (+startV[2]); 
    const  endSeconds = (+endV[0]) * 60 * 60 + (+endV[1]) * 60 + (+endV[2]); 
    console.log({startSeconds},{endSeconds});
    const diff = endSeconds - startSeconds
    return this.fancyTimeFormat(diff)
  }

  fancyTimeFormat(duration: any) {
    // Hours, minutes and seconds
    const hrs = ~~(duration / 3600);
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;

    return ret;
  }
}
